export const CITIES = [
  {
    slug: "toronto",
    name: "Toronto",
    metaTitle: "Garage Door Repair Toronto | 24/7 GTA Service",
    metaDescription:
      "Need garage door repair or a locksmith in Toronto? GTA Garage Doors responds in 60 minutes. Licensed, insured, available 24/7. Call now.",
    intro:
      "From downtown Toronto condos with tight laneway garages to detached family homes in the Beaches, Leslieville, High Park, and Forest Hill - Toronto is our home base. Our Toronto technicians live in Toronto, know every neighbourhood, and are dispatched directly from Toronto-area trucks. If you're anywhere inside the city of Toronto and your garage door or locks are failing, we can usually be parked in your driveway within 45 minutes. Toronto homeowners get the same promise we give every GTA client: licensed, insured, and a real tech at your door fast.",
    testimonial: {
      name: "David L.",
      city: "Toronto (Leslieville)",
      quote:
        "My garage door cable snapped while I was pulling in. Called GTA Garage Doors, they were at my place in East York within 40 minutes. Replaced both cables, tuned the springs, and I was back in my garage in under an hour. Exactly what you want from an emergency call.",
    },
  },
  {
    slug: "vaughan",
    name: "Vaughan",
    metaTitle: "Garage Door Repair Vaughan | Fast Local Service",
    metaDescription:
      "Garage door broken in Vaughan? Our local techs respond fast - springs, openers, break-in repairs, locksmith services. Call GTA Garage Doors now.",
    intro:
      "Vaughan homes - from Woodbridge to Maple to Thornhill-Vaughan - are served daily by our technicians. Vaughan's mix of newer subdivisions and established neighbourhoods means we see everything here: modern insulated doors on Kleinburg estates, 20-year-old openers in Maple, and emergency lockouts in Concord. Our Vaughan response time averages 45 minutes. No Vaughan homeowner should wait hours for a tech to show up - not in -20 weather, not at 2am, not ever. Call and we move.",
    testimonial: {
      name: "Priya S.",
      city: "Vaughan (Woodbridge)",
      quote:
        "Our garage door wouldn't close on the coldest night of the year and we couldn't leave the house unsecured. GTA Garage Doors took my 10pm call, dispatched a tech from Vaughan, and the door was fixed by 11:15. These guys are the real thing.",
    },
  },
  {
    slug: "mississauga",
    name: "Mississauga",
    metaTitle: "Garage Door Repair Mississauga | 60-Min Response",
    metaDescription:
      "Fast garage door and locksmith service in Mississauga. Emergency repairs, spring replacement, lock change. Licensed & insured. Call us 24/7.",
    intro:
      "Mississauga is one of our busiest service areas - Port Credit, Streetsville, Meadowvale, Erin Mills, Square One, Clarkson, and Cooksville all see our trucks daily. Mississauga's detached homes and townhouses mean most service calls involve spring replacements, opener repairs, and emergency lockouts. Our Mississauga technicians are licensed, insured, and carry full stock for same-day completion. Most Mississauga calls are answered in under 60 minutes, any hour, any day of the year.",
    testimonial: {
      name: "Kevin M.",
      city: "Mississauga (Erin Mills)",
      quote:
        "Locked out of my house on a Sunday morning. Called three places. GTA Garage Doors was the only one that answered and they had a licensed locksmith at my front door in 35 minutes. Zero damage to my lock, great service.",
    },
  },
  {
    slug: "brampton",
    name: "Brampton",
    metaTitle: "Garage Door Repair Brampton | Same-Day Service",
    metaDescription:
      "Locked out or garage door broken in Brampton? GTA Garage Doors dispatches fast. Same-day repairs, 24/7 availability. Call now.",
    intro:
      "Brampton homeowners in Bramalea, Mount Pleasant, Heart Lake, Fletcher's Meadow, Springdale, and Downtown Brampton rely on us for emergency garage door and locksmith service. Brampton's rapid growth means a lot of 15-20 year old garage doors are now failing - springs, cables, and openers are our most common Brampton jobs. Same-day service is the norm, not the exception. Brampton calls are typically on-site within an hour.",
    testimonial: {
      name: "Harpreet K.",
      city: "Brampton (Mount Pleasant)",
      quote:
        "The spring on our double garage door snapped Saturday morning and both cars were trapped inside. GTA Garage Doors had a tech in Brampton within an hour, replaced both springs properly, and we were out by lunch. Exactly what we needed.",
    },
  },
  {
    slug: "markham",
    name: "Markham",
    metaTitle: "Garage Door Repair Markham | Licensed Technicians",
    metaDescription:
      "Garage door or locksmith emergency in Markham? We cover all of Markham with fast, licensed technicians. Call GTA Garage Doors 24/7.",
    intro:
      "Markham service calls take us from Unionville to Cornell, Berczy Village to Cathedraltown, Cachet to Milliken. Markham homes often have higher-end garage door installations that demand specific parts and brand-matched hardware - we carry them. Our licensed Markham technicians respond fast and work clean. 24/7 emergency availability across all of Markham, including holidays.",
    testimonial: {
      name: "Emily C.",
      city: "Markham (Unionville)",
      quote:
        "Our LiftMaster opener just died and we thought we needed a whole new unit. The GTA Garage Doors tech in Markham diagnosed it as a worn capacitor, fixed it on the spot, and saved us from an unnecessary full replacement. Honest work.",
    },
  },
  {
    slug: "richmond-hill",
    name: "Richmond Hill",
    metaTitle: "Garage Door Repair Richmond Hill | Fast Response",
    metaDescription:
      "Need a garage door repair or locksmith in Richmond Hill? Our techs are nearby and ready 24/7. Call GTA Garage Doors for fast local service.",
    intro:
      "Richmond Hill is covered 24/7 - from Oak Ridges to Bayview Hill to Mill Pond and Jefferson. Richmond Hill's upscale neighbourhoods mean high-end garage doors and premium hardware, and we carry the parts and experience to service both. Richmond Hill response times average 50-60 minutes, often faster during the day. Licensed, insured, and dispatched from GTA-local trucks.",
    testimonial: {
      name: "Andrew W.",
      city: "Richmond Hill (Bayview Hill)",
      quote:
        "Garage door went off the track at 10pm on a Tuesday. I had three quotes by morning, but GTA Garage Doors was the only one who actually showed up in Richmond Hill the same night. Professional from start to finish.",
    },
  },
  {
    slug: "thornhill",
    name: "Thornhill",
    metaTitle: "Garage Door Repair Thornhill | GTA Garage Doors",
    metaDescription:
      "Garage door off track or locked out in Thornhill? We're close by and ready to help. Licensed techs, 24/7 service. Call GTA Garage Doors now.",
    intro:
      "Thornhill - split across Vaughan and Markham - is central to our service network. Thornhill's classic homes on streets like Bathurst, Yonge, Royal Orchard, and Spadina Road see us regularly for spring replacement, opener repair, and residential locksmith work. Thornhill response time is usually under 45 minutes. Our local Thornhill techs are licensed, insured, and work 24/7.",
    testimonial: {
      name: "Rachel B.",
      city: "Thornhill",
      quote:
        "Someone tried to force our back door. I called GTA Garage Doors in a panic at 6am and they had a technician in Thornhill by 7. New deadbolt, reinforced strike plate, peace of mind. Thank you.",
    },
  },
  {
    slug: "north-york",
    name: "North York",
    metaTitle: "Garage Door Repair North York | 24/7 Emergency",
    metaDescription:
      "Emergency garage door repair and locksmith service in North York. Fast response, licensed & insured, 24/7 availability. Call us any time.",
    intro:
      "North York service runs from Yonge-Eglinton up to Steeles, Don Mills to Jane-Finch, Bayview Village to Willowdale. North York's mix of detached homes, townhouses, and condos keeps our techs busy with every kind of garage door and locksmith job. 24/7 emergency service is fully covered across all of North York. Licensed, insured, and fast.",
    testimonial: {
      name: "Marcus H.",
      city: "North York (Willowdale)",
      quote:
        "My wife was locked out with both kids and no phone. I called GTA Garage Doors from work, they dispatched a locksmith to North York in 30 minutes and had everyone safely inside. Huge relief.",
    },
  },
  {
    slug: "etobicoke",
    name: "Etobicoke",
    metaTitle: "Garage Door Repair Etobicoke | Fast Local Techs",
    metaDescription:
      "Broken garage door or lock emergency in Etobicoke? GTA Garage Doors has licensed techs nearby. Call now for fast, reliable service.",
    intro:
      "Etobicoke - from Mimico and New Toronto to Rexdale, Markland Wood, Humber Bay, and Kingsway - is fully covered 24/7. Etobicoke's mix of older bungalows with aging openers and newer townhouses with modern insulated doors keeps our techs working. Most Etobicoke calls are on-site in under an hour. Licensed Etobicoke technicians and same-day repair.",
    testimonial: {
      name: "Linda P.",
      city: "Etobicoke (Kingsway)",
      quote:
        "Garage door opener died right before a family trip. Called GTA Garage Doors, tech was in Etobicoke within the hour, installed a brand-new belt-drive unit, and we made our flight. Absolute lifesavers.",
    },
  },
  {
    slug: "scarborough",
    name: "Scarborough",
    metaTitle: "Garage Door Repair Scarborough | Same-Day Fixes",
    metaDescription:
      "Same-day garage door repair and locksmith service in Scarborough. Springs, openers, break-in repairs. Licensed & insured. Call GTA Garage Doors.",
    intro:
      "Scarborough - from Agincourt to West Hill, Cliffside to Malvern, Guildwood to Wexford - is one of our highest-volume service areas. Scarborough homes of every vintage see everything from emergency lockouts to spring replacements to full break-in repairs. Our Scarborough techs are local, licensed, and usually parked in your driveway within an hour of your call. Same-day fixes are the standard.",
    testimonial: {
      name: "Sandra K.",
      city: "Scarborough",
      quote:
        "Someone tried to kick in my back door overnight. I called at 6am panicking and they were here by 7:15. New door frame, new lock, everything secured before my kids woke up. I can't say enough good things.",
    },
  },
  {
    slug: "oakville",
    name: "Oakville",
    metaTitle: "Garage Door Repair Oakville | GTA Garage Doors",
    metaDescription:
      "Fast garage door repair and locksmith service in Oakville. Licensed techs, 24/7 availability, same-day repair. Call GTA Garage Doors now.",
    intro:
      "Oakville homes - from Bronte to Glen Abbey, Old Oakville to Iroquois Ridge and Joshua Creek - get full GTA-level service. Oakville's upscale garage door installations often need premium parts and careful handling; our licensed Oakville technicians carry exactly that. 24/7 availability, transparent pricing, and fast response across every Oakville neighbourhood.",
    testimonial: {
      name: "Tom F.",
      city: "Oakville (Glen Abbey)",
      quote:
        "My custom wood garage door was sticking in the humidity. GTA Garage Doors sent an experienced tech out to Oakville who diagnosed it, adjusted the tracks, and balanced the springs. No upsell, no hassle. First-class service.",
    },
  },
  {
    slug: "burlington",
    name: "Burlington",
    metaTitle: "Garage Door Repair Burlington | 24/7 Response",
    metaDescription:
      "Need a garage door tech or locksmith in Burlington? GTA Garage Doors covers Burlington 24/7. Fast response, licensed techs. Call us now.",
    intro:
      "Burlington service covers Aldershot, Downtown Burlington, Alton, Millcroft, Roseland, and Tyandaga 24/7. Burlington homeowners get the same promise as every GTA client: licensed and insured technicians, same-day repair, no surprises. Call us any hour - we're dispatching a Burlington tech to your driveway fast.",
    testimonial: {
      name: "Nicole D.",
      city: "Burlington (Millcroft)",
      quote:
        "Came home from work to find my garage door stuck halfway open with the car inside. GTA Garage Doors had a tech in Burlington within 50 minutes, fixed a snapped cable and a bad roller, and had me sorted the same afternoon. Easy five stars.",
    },
  },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
